"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StubErrorService = void 0;
const ErrorService_1 = require("../ErrorService");
/** A blank error service that does nothing. */
class StubErrorService extends ErrorService_1.ErrorService {
    /** {@inheritDoc ErrorService.clearUserContext} */
    clearUserContext() { }
    /** {@inheritDoc ErrorService.setContext} */
    setContext() { }
    /** {@inheritDoc ErrorService.leaveBreadcrumb} */
    leaveBreadcrumb(message, level, data, category) { }
    /** {@inheritDoc ErrorService.reportError} */
    // eslint-disable-next-line node/handle-callback-err
    reportError(error, context) { }
    /** {@inheritDoc ErrorService.setUserContext} */
    _setUserContext(user) {
        return user;
    }
    /** {@inheritDoc ErrorService.sync} */
    sync() {
        return Promise.resolve();
    }
    _getStubSpan() {
        return {
            end: () => { },
            getAttribute: key => undefined,
            setAttribute: () => { },
            getSampled: () => false,
            setSampled: () => { },
        };
    }
    getCurrentSpan() {
        return this._getStubSpan();
    }
    span(opts, callback) {
        return callback(this._getStubSpan());
    }
    startSpan(opts) {
        return this._getStubSpan();
    }
}
exports.StubErrorService = StubErrorService;
//# sourceMappingURL=StubErrorService.js.map